import { render, staticRenderFns } from "./VNotificationGroup.vue?vue&type=template&id=3755d634&"
import script from "./VNotificationGroup.vue?vue&type=script&lang=js&"
export * from "./VNotificationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports